import { message } from 'antd';
import { GitCredentialsSetup } from '../../components/git/GitCredentialsSetup';
import { SchemaGitConnectionForm } from '../../components/schema/SchemaGitConnectionForm';
import { ensureGitFileViewerReady } from '../../bootstrap/gitFileViewer';
import { useDeferredModule } from '../../hooks/useDeferredModule';
import { useSchemaGitSettings } from '../../hooks/useSchemaGitSettings';
import './GitCredentialsPage.css';

export function GitCredentialsPage() {
  const gitReady = useDeferredModule(ensureGitFileViewerReady);
  const {
    settings,
    draft,
    setDraft,
    applyDraft,
    resetDraftToEnvDefaults,
    connectionChanged,
  } = useSchemaGitSettings();

  if (!gitReady) {
    return null;
  }

  const handleApply = () => {
    const next = applyDraft();
    if (!next) {
      message.error('请填写 Git 仓库 URL');
      return;
    }
    message.success('已更新目标仓库');
  };

  return (
    <div className="dc-admin-git-credentials-page">
      <SchemaGitConnectionForm
        draft={draft}
        onDraftChange={setDraft}
        onApply={handleApply}
        onResetEnvDefaults={resetDraftToEnvDefaults}
        connectionChanged={connectionChanged}
      />
      <GitCredentialsSetup
        repoUrl={settings.repoUrl}
        hint={`配置访问 Schema Git 仓库的 SSH 私钥。当前仓库：${settings.repoUrl || '（请先填写并应用仓库 URL）'}`}
      />
    </div>
  );
}
